import { SERVERS } from '../data/servers';

export const BANKS = ['CIH Bank', 'Attijariwafa Bank', 'BMCE Bank of Africa', 'Banque Populaire', 'Crédit du Maroc', 'Société Générale', 'Barid Bank'];

export const BUY_STEPS = [
  { title: 'Choisissez votre serveur', text: 'Draconiros, Imagiro, Tal Kasha, Hell Mina, Boune, Kelerog… et la quantité de Kamas voulue.' },
  { title: 'Indiquez votre personnage', text: "Nom du personnage et email : c'est tout ce qu'il faut pour vous livrer." },
  { title: 'Payez en DH', text: 'Virement depuis CIH, Attijariwafa, Barid Bank, BMCE ou Banque Populaire. Envoyez la preuve dans le chat.' },
  { title: 'Recevez vos Kamas', text: "Un conseiller vous remet les Kamas en jeu et confirme la commande dans le chat." },
];

export const SELL_STEPS = [
  { title: 'Sélectionnez le serveur', text: 'Dofus 3, Dofus Rétro ou Dofus Touch : les 20 serveurs officiels sont acceptés.' },
  { title: 'Indiquez la quantité', text: 'Le montant en dirhams est calculé automatiquement au prix du jour.' },
  { title: 'Renseignez votre RIB', text: 'Titulaire, banque et RIB pour recevoir le virement en DH.' },
  { title: 'Échangez et soyez payé', text: "Vous remettez les Kamas en jeu, nous envoyons le virement et la preuve dans le chat." },
];

export const FAQ = [
  {
    q: 'Comment faire un achat de Kamas au Maroc ?',
    a: "Choisissez votre serveur Dofus, Dofus Rétro ou Dofus Touch, indiquez la quantité et votre personnage, puis réglez en dirhams par virement bancaire marocain. Un conseiller suit votre commande dans le chat et vous remet les Kamas en jeu.",
  },
  {
    q: 'Comment vendre mes Kamas Dofus contre des dirhams ?',
    a: "Remplissez le formulaire de vente avec votre serveur, la quantité et votre RIB (CIH, Attijariwafa, Barid Bank, BMCE, Banque Populaire…). Après l'échange en jeu, nous vous payons par virement en DH.",
  },
  {
    q: 'Quels serveurs Dofus acceptez-vous ?',
    a: `Les ${SERVERS.length} serveurs officiels : ${SERVERS.map(s => s.name).join(', ')}.`,
  },
  {
    q: 'Vos prix sont-ils moins chers que TryAndJudge ?',
    a: "Nos prix sont calculés à partir des prix publics de TryAndJudge, mis à jour automatiquement : quand vous achetez, vous payez moins cher (jusqu'à 1 DH de moins par million), et quand vous vendez, nous vous payons plus (jusqu'à 1 DH de plus par million). L'écart exact par serveur est visible dans notre comparatif.",
  },
  {
    q: 'Quels moyens de paiement sont acceptés ?',
    a: `Le virement bancaire depuis les principales banques marocaines : ${BANKS.join(', ')}.`,
  },
  {
    q: 'Combien de temps prend une commande de Kamas ?',
    a: "La commande est traitée dès réception du paiement ou des Kamas. Vous suivez chaque étape en direct dans le chat du service client, où vous pouvez aussi envoyer votre preuve de paiement.",
  },
  {
    q: 'Faut-il créer un compte pour acheter ou vendre des Kamas ?',
    a: "Un compte gratuit permet de retrouver l'historique de vos commandes et de discuter avec le support. L'inscription prend moins d'une minute.",
  },
  {
    q: 'Le prix affiché est-il par million de Kamas ?',
    a: "Oui, tous les prix sont exprimés en dirhams marocains (DH / MAD) pour 1 million de Kamas (1M). Le total est calculé automatiquement selon la quantité.",
  },
];

export const faqJsonLd = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: items.map(item => ({
    '@type': 'Question',
    name: item.q,
    acceptedAnswer: { '@type': 'Answer', text: item.a },
  })),
});
